import React from 'react';

const ThemeSelector: React.FC = () => null;
export default ThemeSelector;
